import { endpoints } from '@rossum/api-client';
import { useQueries } from '@tanstack/react-query';
import * as R from 'remeda';
import * as z from 'zod';
import { useApiClient } from '../../../../../../../lib/apiClient';
import { useHookInterfaces } from '../../../../../../extension-interop/hooks/useHookInterfaces';
import { externalHookTemplateSchema } from '../customExtensionSchema';

export const useExternalHookTemplates = () => {
  const api = useApiClient();

  const { data: storeIntegrations, isLoading: hooksLoading } =
    useHookInterfaces({
      type: 'store',
      canInvoke: true,
    });

  const results = useQueries({
    queries:
      storeIntegrations?.results.map(hookInterface => ({
        queryKey: ['@store', 'extension_list', hookInterface.id],
        queryFn: () =>
          api.request(
            endpoints.hookInterfaces.invoke(hookInterface.id, {
              payload: {
                name: 'get_hook_template_list',
              },
            })
          ),
      })) ?? [],
  });

  const hookTemplates = R.flatMap(results, (result, index) =>
    R.pipe(
      result.data,
      storeResponse => {
        if (!storeResponse) {
          return [];
        }

        const parsed = z
          .array(z.object({ id: z.string(), hook_template: z.unknown() }))
          .safeParse(storeResponse);

        if (!parsed.success) {
          // eslint-disable-next-line no-console
          console.warn(parsed.error);
          return [];
        }

        return parsed.data;
      },
      entry =>
        R.pipe(
          entry,
          R.map(({ id: externalHookTemplateId, hook_template }) => {
            const parsed = externalHookTemplateSchema.safeParse(hook_template);

            if (!parsed.success) {
              // eslint-disable-next-line no-console
              console.warn(parsed.error);
              return undefined;
            }

            return {
              externalHookTemplateId,
              hookTemplate: parsed.data,
              hookInterface: storeIntegrations?.results[index],
            };
          }),
          R.filter(R.isDefined)
        )
    )
  );

  const isLoading = hooksLoading || results.some(result => result.isLoading);

  return { data: hookTemplates, isLoading };
};
